import { FETCH_PRODUCT_MAIN_INFO } from 'features/product-info';
import { call, put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { selectPagePath } from './selectors';

/**
 * событие должно срабатывать при отображении страницы пользователю
 * и при переходах между страницами (в том числе при изменении
 * get-параметров в url).
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaPageView = createAction('GA:pageview')<{
  pageType: 'ProductPage'; // тип страницы
  pagePath: string; // путь к странице
}>();

export function* putGaPageView() {
  yield put(
    gaPageView({
      pageType: 'ProductPage',
      pagePath: yield call(selectPagePath),
    }),
  );
}

export function* runPageViewDetector() {
  yield takeEvery(FETCH_PRODUCT_MAIN_INFO.success, putGaPageView);
}
